import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SowChangeSelectScopeTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_SELECT_SCOPE),
});
